/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */

import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject ,  Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommonService } from './common.service';
@Injectable()
export class PaymentsService {
  private masterColumnsAndFiltersUrl: string = environment.host + '/compensation/analytics/metadata';
  private applyFiltersUrl: string = environment.host + '/payment/filter';
  private applyFiltersUrlAP: string = environment.host + '/adhocpayments/filter';
  private currentPeriodUrl: string = environment.host + '/currentperiod';
  private paymentsReportUrl: string = environment.host + '/report/PaymentReports';
  private paymentsReportUrlAP: string = environment.host + '/report/AdhocPaymentReports';
  private ArchivedapplyFiltersUrl: string = environment.host + '/payment/archive/filter';
  private multiSortColumns: any = [];
  public invokeCancelRequest: Observable<any>;
  public isCancelRequest: Subject<any>;
  
  constructor(private http: HttpClient,private commonService: CommonService) {
    this.isCancelRequest = new Subject<boolean>();
    this.invokeCancelRequest = this.isCancelRequest.asObservable();
  }

  public getCurrentPeriod(regionCode: string) {
    if (regionCode) {
      return this.http.get(this.currentPeriodUrl + '?regionCode=' + regionCode).toPromise();
    } else {
      return this.http.get(this.currentPeriodUrl).toPromise();
    }
  }

  public cancelRequest(val: any) {
    this.isCancelRequest.next(val);
  }

  public getMultiSortColumns() {
    return this.multiSortColumns;
  }

  public setMultiSortColumns(columns: any) {
    this.multiSortColumns = columns;
  }

  public loadMasterColumnsAndFilters() {
    return this.http.get(this.masterColumnsAndFiltersUrl).toPromise();
  }

  public getMembers(payload: any, startRecord: any, recordsSize: any, periodPosition: any) {
    const archiveMapping: any = {
        "Position": "PositionArchive",
        "Participant": "ParticipantArchive",
        "Payment": "PaymentArchive"
    };
    const routePath = this.commonService.ActivatedSideSubMenu === "Archived";
    if (routePath) {
        payload.sourceTypes = payload.sourceTypes.map((type: any) => archiveMapping[type] || type);
    }
    const filterURL = `${routePath ? this.ArchivedapplyFiltersUrl : this.applyFiltersUrl}?pageMaxId=${startRecord}&size=${recordsSize}&currentPeriod=${periodPosition === undefined ? true : periodPosition}`;
    return this.http.post(filterURL, payload).pipe(
        map(response => response));
  }

  /** 
   * 
   * get Members for Adhoc Payment
  */
  public getMembersAP(payload: any, startRecord: any, recordsSize: any, periodPosition: any) {
    const filterURL = this.applyFiltersUrlAP + '?pageMaxId=' + startRecord + '&size=' + recordsSize + '&currentPeriod=' + ((periodPosition == undefined) ? true : periodPosition);
    return this.http.post(filterURL, payload).pipe(
      map(response => response));
  }

  public getDefaultReportDetails() {
    return this.http.get((this.paymentsReportUrl).toString()).toPromise();
  }

  public getDefaultReportDetailsAP() {
    return this.http.get((this.paymentsReportUrlAP).toString()).toPromise();
  }

  public releaseHeldPayment(payload: any) {
    const url = environment.host + '/payment/releaseHeldPayment';
    return this.http.post(url, payload).toPromise();
  }
}